export default __webpack_public_path__ + "locales/nl/DeleteSelfProfileDialog.json?hash=8a67696fd58b5758ac3babbc0ebd77df";